import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild,ViewEncapsulation } from '@angular/core';
import { TermsConditionPopup } from "../models/terms-condition-popup.service";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";

@Component({
  selector: 'wego-terms-condition-popup',
  template: require('../views/terms-and-conditions-popup.component.html'),
  providers: [TermsConditionPopup],
  encapsulation: ViewEncapsulation.None,
  styles: [ `
  span.popimgstyle img {
    max-width: 100% !important;
    height: auto !important;
}
`]
})

export class TermsAndConditionsPopup implements OnInit {
  @ViewChild('termsConditionModel') public termsConditionModel: ModalDirective;

  bodyHTMLText: string;

  constructor(
    private termsConditionPopup: TermsConditionPopup,
    private authService: AuthService
  ) { }

  ngOnInit() {

  }

  private Confirm($event: any) {
    this.hide();
    //this.onConfirm.emit($event);
  }

  public show(bodyHTMLText: string) {
    this.bodyHTMLText = bodyHTMLText;
    this.termsConditionModel.show();
  }

  public hide() {
    this.termsConditionModel.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsconditionpopup/components/terms-and-conditions-popup.component.ts